import React from "react";
import image from "../assets/Naivedh.jpeg"
function Home(props) {
  return (
    <div className="home" data-aos={"fade-up"}>
      <div className="row image__main">
        <div className="col-sm-12">
          <img src={image} alt="Naivedh" />
        </div>
      </div>
      <div className="row title my-4">
        <div className="col-sm-12">Web Developer | Data Analyst</div>
      </div>
      <div className="row title my-4">
        <div className="col-sm-12">
        <a rel="noreferrer" href="https://github.com/Naivedh" target="_blank"><i className="icon mx-3 fab fa-lg fa-github"></i></a>
        <a rel="noreferrer" href="https://www.linkedin.com/in/naivedh-shah/" target="_blank"><i className="icon mx-3 fab fa-lg fa-linkedin-in"></i></a>
        <a rel="noreferrer" href="https://twitter.com/shah_naivedh" target="_blank"><i className="icon mx-3 fab fa-lg fa-twitter"></i></a>
        <a rel="noreferrer" href="mailto:naivedhshah1999@gmail.com" target="_blank"><i className="icon mx-3 fas fa-lg fa-envelope"></i></a>
        <a rel="noreferrer" href="https://www.instagram.com/shah_naivedh/" target="_blank"><i className="icon mx-3 fab fa-lg fa-instagram"></i></a>
        </div>
      </div>
    </div>
  );
}

export default Home;
